import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {
  faSearch,
  faCircleInfo,
  faRotateRight,
  faTrash,
  faArrowRightLong,
} from '@fortawesome/free-solid-svg-icons';
import { catchError, throwError } from 'rxjs';
import { RequestsService } from 'src/app/services/requests.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmWithdrawComponent } from 'src/app/components/confirm-withdraw/confirm-withdraw.component';
import { RequestHistoryInfoComponent } from 'src/app/components/request-history-info/request-history-info.component';
import { ResourceRenewalComponent } from 'src/app/components/resource-renewal/resource-renewal.component';
import { TransferComponent } from 'src/app/components/transfer/transfer.component';
import { ConfirmNewDeprovisioningComponent } from 'src/app/components/confirm-new-deprovisioning/confirm-new-deprovisioning.component';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { RequestInfoComponent } from 'src/app/components/request-info/request-info.component';
import { HandlerSnackbarService } from 'src/app/services/handler-snackbar.service';
import { NewRequestFormService } from 'src/app/services/new-request-form.service';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss'],
})
export class RequestsComponent implements OnInit {
  [x: string]: any;
  faTrash = faTrash;
  faCircleInfo = faCircleInfo;
  faRotateRight = faRotateRight;
  faRightFromLine = faArrowRightLong;
  displayedColumnsPending: string[] = [
    'lastApproval',
    'type',
    'id',
    'assignee',
    'status',
    'details',
    'delete',
  ];
  displayedColumnsProvided: string[] = [
    'lastApproval',
    'type',
    'id',
    'expiration',
    'details',
    'renew',
  ];
  displayedColumnsHistory: string[] = [
    'submittedAt',
    'resolved',
    'type',
    'id',
    'status',
    'details',
  ];
  pendingDataSource: any;
  providedDataSource: any;
  historyDataSource: any;
  faSearch = faSearch;
  tab: string = 'pending';

  @ViewChild(MatSort) sortPending = new MatSort();
  @ViewChild(MatSort) sortProvided = new MatSort();
  @ViewChild(MatSort) sortHistory = new MatSort();

  constructor(
    private readonly reqService: RequestsService,
    private readonly newRequestFormService: NewRequestFormService,
    private readonly modalService: NgbModal,
    private readonly cdRef: ChangeDetectorRef,
    private readonly alertService: HandlerSnackbarService,
    private readonly utilities: UtilitiesService,
    private readonly spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.spinnerService.open();
    this.reqService.getAllPendingRequests();
    this.getPendingRequestList();
    this.getProvidedRequestList();
    this.getHistoryRequestList();
    this.initSort();
  }

  initSort() {
    this.cdRef.detectChanges();
    if (this.pendingDataSource) this.pendingDataSource.sort = this.sortPending;
    if (this.providedDataSource)
      this.providedDataSource.sort = this.sortProvided;
    if (this.historyDataSource) this.historyDataSource.sort = this.sortHistory;

    this.cdRef.detectChanges();
  }

  getRequest(requestId: string) {
    this.reqService
      .getRequest(requestId)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            console.error(error);
          });
        })
      )
      .subscribe((data: any) => {
        console.log(data);
      });
  }

  getPendingRequestList() {
    this.reqService
      .getPendingRequestList()
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            console.error(error);
          });
        })
      )
      .subscribe((data: any) => {
        this.pendingDataSource = new MatTableDataSource(data);
        this.pendingDataSource.sort = this.sortPending;
        this.pendingDataSource.sortingDataAccessor = (
          item: any,
          property: string
        ) => {
          if (property == "submittedAt") return this.utilities.transformDate(item.submittedAt);
          return item[property];
        };
        this.spinnerService.close();
      });
  }

  getProvidedRequestList() {
    this.reqService
      .getProvidedRequestList()
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            console.error(error);
          });
        })
      )
      .subscribe((data: any) => {
        this.providedDataSource = new MatTableDataSource(data);
        this.providedDataSource.sort = this.sortProvided;
        this.providedDataSource.sortingDataAccessor = (
          item: any,
          property: string
        ) => {
          if (property == "approvalAt") return this.utilities.transformDate(item.approvalAt);
          return item[property];
        };
        this.spinnerService.close();
      });
  }

  getHistoryRequestList() {
    this.reqService
      .getHistoryRequestList()
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            console.error(error);
          });
        })
      )
      .subscribe((data: any) => {
        this.historyDataSource = new MatTableDataSource(data);
        this.historyDataSource.sort = this.sortHistory;
        this.historyDataSource.sortingDataAccessor = (
          item: any,
          property: string
        ) => {
          switch (property) {
            case 'submittedAt':
              return this.utilities.transformDate(item.submittedAt);
            case 'resolvedAt':
              return this.utilities.transformDate(item.resolvedAt);
            default:
              return item[property];
          }
        };
        this.spinnerService.close();
      });
  }

  deprovisioning(element: any) {
    const modalRef = this.modalService.open(ConfirmNewDeprovisioningComponent, {
      size: 'md',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          this.alertService.viewUserMessage();
          this.reqService
            .newDeprovisioning(result.id)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                return this.alertService.handlerErrorSubscribe(error);
              })
            )
            .subscribe((data: any) => {
              console.log(data);
              this.reqService.getAllProvidedRequests();
              this.alertService.viewUserClosingMessage(
                'Operazione conclusa con successo',
                'withdraw-snackbar'
              );
            });
        }
      },
      (error) => {
        console.log(error);
      }
    );

    modalRef.componentInstance.info = element;
  }

  withdrawModal(element: any) {
    const modalRef = this.modalService.open(ConfirmWithdrawComponent, {
      size: 'md',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          this.alertService.viewUserMessage();
          this.reqService
            .withdrawRequest(result.id)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                return this.alertService.handlerErrorSubscribe(error);
              })
            )
            .subscribe((data: any) => {
              console.log(data);
              this.reqService.getAllPendingRequests();
              this.alertService.viewUserClosingMessage(
                'Richiesta revocata con successo',
                'withdraw-snackbar'
              );
            });
        }
      },
      (error) => {
        console.log(error);
      }
    );

    modalRef.componentInstance.info = element;
  }

  infoPendingModal(element: any) {
    const modalRef = this.modalService.open(RequestInfoComponent, {
      size: 'lg',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          console.log(result);
        }
      },
      (error) => {
        console.log(error);
      }
    );

    modalRef.componentInstance.info = element;
    modalRef.componentInstance.title = 'REQUEST_SUBMITTED';
    modalRef.componentInstance.hasWithdrawModal = true;
  }

  infoProvidedModal(element: any) {
    const modalRef = this.modalService.open(RequestInfoComponent, {
      size: 'lg',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          console.log(result);
        }
      },
      (error) => {
        console.log(error);
      }
    );

    modalRef.componentInstance.info = element;
    modalRef.componentInstance.title = 'PROVISIONED_REQUEST_INFO.DETAILS';
    modalRef.componentInstance.hasWithdrawModal = false;
  }

  infoHistoryModal(element: any) {
    const modalRef = this.modalService.open(RequestHistoryInfoComponent, {
      size: 'lg',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          console.log(result);
        }
      },
      (error) => {
        console.log(error);
      }
    );

    modalRef.componentInstance.info = element;
  }

  renewModal(element: any) {
    const modalRef = this.modalService.open(ResourceRenewalComponent, {
      size: 'md',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        this.alertService.viewUserMessage();
        if (result) {
          console.log(result);
          this.reqService
            .completeRenew(result)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                return this.alertService.handlerErrorSubscribe(error);
              })
            )
            .subscribe((data: any) => {
              console.log(data);
              this.reqService.getAllProvidedRequests();
              this.alertService.viewUserClosingMessage(
                'Richiesta di rinnovo inoltrata',
                'success-snackbar'
              );
            });
        }
      },
      (error) => {
        console.log(error);
      }
    );

    modalRef.componentInstance.item = element;
  }

  transferModal(element: any) {
    const modalRef = this.modalService.open(TransferComponent, {
      size: 'md',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        this.alertService.viewUserMessage();
        if (result) {
          console.log(result);
        }
      },
      (error) => {
        console.log(error);
      }
    );

    modalRef.componentInstance.item = element;
  }

  newReqModal() {
    this.newRequestFormService.newReqModal();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.pendingDataSource.filter = filterValue.trim().toLowerCase();
    this.providedDataSource.filter = filterValue.trim().toLowerCase();
    this.historyDataSource.filter = filterValue.trim().toLowerCase();
  }

  tabChange(selTab: string) {
    this.tab = selTab;
    this.spinnerService.open();
    switch (selTab) {
      case 'pending':
        this.reqService.getAllPendingRequests();
        break;
      case 'provided':
        this.reqService.getAllProvidedRequests();
        break;
      case 'history':
        this.reqService.getAllHistoryRequests();
        break;
      default:
        this.spinnerService.close();
    }
    this.initSort();
  }
}
